// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__nQGe8","titleHeader":"styles_titleHeader__+TZmf"};